import React, { useState } from "react";
import "./riskFactorForm.css";
import { runCustomScenario } from "../../services/riskFactor/riskFunction";
import { contentTypeEnum } from "../../util/enums";

export default function RiskFactorForm({
  sendToolResponse,
  setCurrentContentType,
  setOutputText,
}) {
  const [dataCalculated, setDataCalculated] = useState(null);

  const labels = {
    changeInVix: "Change In Vix (%)",
    highYieldVs10YrTreasury: "High Yield Vs 10 Yr Treasury (bps)",
    industrialACreditVs10YrTreasury:
      "Industrial A Credit Vs 10 Yr Treasury (bps)",
    msciACWIxUSA: "MSCI ACWI ex-USA (%)",
    nasdaq: "Nasdaq (%)",
    sp500: "S&P 500 (%)",
  };

  const [formData, setFormData] = useState({
    changeInVix: "",
    highYieldVs10YrTreasury: "",
    industrialACreditVs10YrTreasury: "",
    msciACWIxUSA: "",
    nasdaq: "",
    sp500: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const percentages = Array(17).fill(null);
    percentages[5] =
      formData.changeInVix === "" ? null : Number(formData.changeInVix);
    percentages[9] =
      formData.highYieldVs10YrTreasury === ""
        ? null
        : Number(formData.highYieldVs10YrTreasury);
    percentages[10] =
      formData.industrialACreditVs10YrTreasury === ""
        ? null
        : Number(formData.industrialACreditVs10YrTreasury);
    percentages[11] =
      formData.msciACWIxUSA === "" ? null : Number(formData.msciACWIxUSA);
    percentages[12] = formData.nasdaq === "" ? null : Number(formData.nasdaq);
    percentages[13] = formData.sp500 === "" ? null : Number(formData.sp500);

    const result = runCustomScenario(percentages);

    setDataCalculated({
      title: "Calculated risk factor",
      data: result,
    });

    const confirmationMessage = `Here is the calculated risk factor`;
    window.gptRealtimeControl?.continue?.();

    setOutputText({ title: "Calculated risk factor", data: result });
    setCurrentContentType(contentTypeEnum.historicalRiskFactorDetail);
    sendToolResponse(result, confirmationMessage);
  };

  return (
    <div className="risk-form__wrap">
      <div className="risk-form__panel">
        <h2 className="risk-form__brand">Risk Factor Calculation</h2>

        <form className="risk-form__form" onSubmit={handleSubmit}>
          {Object.keys(formData).map((key) => (
            <label key={key} className="risk-form__label">
              <span>{labels[key]}</span>
              <input
                type="text"
                className="risk-form__input"
                name={key}
                value={formData[key]}
                onChange={handleChange}
              />
            </label>
          ))}

          <button type="submit" className="risk-form__button">
            Calculate
          </button>
        </form>
      </div>
    </div>
  );
}
